import {IPrdictorStore} from "apps/BUDWEISERPOTM/modules/types/store";
import {createSelector} from "reselect";

export const getModalsState = (state: IPrdictorStore) => state.modals;

export const getVoteConfirmationModal = createSelector(
	getModalsState,
	(state) => state.voteConfirmationModalRound
);

export const getBudweiserTermsModal = createSelector(
	getModalsState,
	(state) => state.budweiserTermsModal
);
